import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Team } from './components/Team';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Problems data-id="element-3" />
      <Services data-id="element-4" />
      <HowItWorks data-id="element-5" />
      <Pricing data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Team data-id="element-8" />
      <CTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}